import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtcTimeService {



  constructor(private http: HttpClient) {}

  async fetchUtcTime(): Promise<Date | null> {
    try {
      const url = `${environment.baseUrl}/Yoklama/utc`;

      const response: any = await firstValueFrom(
        this.http.get(url)
      );

      if (response && response.utcDateTime) {
        return new Date(response.utcDateTime);
      }
    } catch (err) {
      console.error("❌ İstek hatası:", err);
    }

    return null;
  }
}
